import './app.css';
import './lib/sentry';
import './lib/posthog';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { resolveLegacyHashRoute } from './lib/legacyHashRoute';

// Old `/#/login`-style links (see lib/legacyHashRoute) are rewritten to the
// real path BEFORE the router mounts, so BrowserRouter reads the corrected
// location on its first render and no route ever sees the hash.
const legacyPath = resolveLegacyHashRoute(window.location.hash);
if (legacyPath) {
  window.history.replaceState(null, '', legacyPath);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);